import "./style.scss";
import { Link } from "react-router-dom";
import TrainingFormatsTouchSvg from "@/src/svg/TrainingFormatsTouchSvg";
import TrainingFormatsOnCampus from "@/src/assets/HomePage/TrainingFormats/TrainingFormatsOnCampus.png";
import TrainingFormatsOnCampusLogo from "@/src/assets/HomePage/TrainingFormats/TrainingFormatsOnCampusLogo.png";
import TrainingFormatsOnline from "@/src/assets/HomePage/TrainingFormats/TrainingFormatsOnline.png";
import TrainingFormatsOnlineLogo from "@/src/assets/HomePage/TrainingFormats/TrainingFormatsOnlineLogo.png";

const TrainingFormatsCards = () => {
  return (
    <div className="training-formats-cards">
      <div className="training-formats-card">
        <img
          className="training-formats-card-img"
          src={TrainingFormatsOnCampus}
          alt="TrainingFormatsOnCampus"
        />
        <div className="training-formats-card-body">
          <TrainingFormatsTouchSvg />
          <img
            className="training-formats-card-body-logo"
            src={TrainingFormatsOnCampusLogo}
            alt="TrainingFormatsOnCampusLogo"
          />
          <p className="training-formats-card-body-title">Очная форма обучения</p>
          <div className="training-formats-card-body-change front">
            <p>Основные преимущества:</p>
            <ul>
              <li>Живое общение с преподавателями;</li>
              <li>Практика на месте;</li>
              <li>Кампусная жизнь студета;</li>
              <li>Быстрая связь обратная связь;</li>
              <li>Доступ к университетской библиотек.</li>
            </ul>
          </div>
          <div className="training-formats-card-body-change back">
            <p className="training-formats-card-body-text">
              <strong>Очная форма</strong> - живое участие в лекциях, семинарах и практиках. Общение
              с преподавателями и студентами, полное погружение в учебный процесс. Активное участие
              в студенческих мероприятиях, новые полезные знакомства.
            </p>
          </div>
        </div>
        <Link to={"/single-page/education-personal"} className="training-formats-card-body-link">
          <span>Подробнее →</span>
        </Link>
      </div>
      <div className="training-formats-card">
        <img
          className="training-formats-card-img"
          src={TrainingFormatsOnline}
          alt="TrainingFormatsOnCampus"
        />
        <div className="training-formats-card-body">
          <TrainingFormatsTouchSvg />
          <img
            className="training-formats-card-body-logo"
            src={TrainingFormatsOnlineLogo}
            alt="TrainingFormatsOnCampusLogo"
          />
          <p className="training-formats-card-body-title">Дистанционная (онлайн) форма</p>
          <div className="training-formats-card-body-change front">
            <p>Основные преимущества:</p>
            <ul>
              <li>Учись из любой точки мира;</li>
              <li>Цифровой формат;</li>
              <li>Свободный график;</li>
              <li>Доступ 24/7;</li>
              <li>Учёба из дома.</li>
            </ul>
          </div>
          <div className="training-formats-card-body-change back">
            <p className="training-formats-card-body-text">
              <strong>Дистанционная (онлайн) форма</strong> - та же программа и диплом, что и у
              студентов на кампусе. Гибкое расписание, онлайн-проекты и обратная связь от
              преподавателей.
            </p>
          </div>
        </div>
        <Link to={"/single-page/education-remotely"} className="training-formats-card-body-link">
          <span>Подробнее →</span>
        </Link>
      </div>
    </div>
  );
};

export default TrainingFormatsCards;
